export const ROUTES = {
	HOME: '/',
	DASHBOARD: '/',
	STUDENTS: '/students',
	STUDENT_PROFILE: '/student_profile',
	PROFILE: '/profile',
	SETTINGS: '/settings',
	USER_MANAGEMENT: '/user-management',
	PARENT_NOTIFICATIONS: '/settings/parent-notifications',
	PARENT_COMMUNICATION: '/settings/parent-communication',
	REPORTS: '/reports',
	SESSIONS: '/sessions',
	MESSAGES: '/messages',
	RESEARCH: '/research',
	CLASSROOM: '/curriculum',
	APPLICATIONS: '/applications',
	APPLICATION_DETAILS: '/applications/:applicationId',
}
